import api from './api';

export interface Campaign {
  id: string;
  workspace_id: string;
  name: string;
  goal: string;
  status: string;
  budget?: number;
  start_date?: string;
  end_date?: string;
  target_audience?: any;
  strategy?: any;
  performance_metrics?: any;
  created_at: string;
}

export interface CampaignStrategy {
  goal: string;
  target_audience: any;
  budget: number;
  duration_days: number;
  constraints?: any;
}

export const campaignsService = {
  getCampaigns: async () => {
    const response = await api.get('/campaigns');
    return response.data;
  },

  getCampaign: async (id: string) => {
    const response = await api.get(`/campaigns/${id}`);
    return response.data;
  },

  createCampaign: async (data: Partial<Campaign>) => {
    const response = await api.post('/campaigns', data);
    return response.data;
  },

  updateCampaign: async (id: string, data: Partial<Campaign>) => {
    const response = await api.put(`/campaigns/${id}`, data);
    return response.data;
  },

  deleteCampaign: async (id: string) => {
    const response = await api.delete(`/campaigns/${id}`);
    return response.data;
  },

  generateStrategy: async (strategy: CampaignStrategy) => {
    const response = await api.post('/campaigns/strategy', strategy);
    return response.data;
  },

  generateContentCalendar: async (campaignId: string) => {
    const response = await api.post(`/campaigns/${campaignId}/content-calendar`);
    return response.data;
  },

  optimizeCampaign: async (campaignId: string, performanceData: any) => {
    const response = await api.post(`/campaigns/${campaignId}/optimize`, {
      performance_data: performanceData,
    });
    return response.data;
  },

  launchCampaign: async (id: string) => {
    const response = await api.post(`/campaigns/${id}/launch`);
    return response.data;
  },

  pauseCampaign: async (id: string) => {
    const response = await api.post(`/campaigns/${id}/pause`);
    return response.data;
  },
};
